import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { AppVariablesService } from '../../service/app-variables.service';
import { AppSettings } from '../../service/app-settings.service';
import { CommonModule } from '@angular/common';

declare var bootstrap: any;

@Component({
  selector: 'theme-panel',
  templateUrl: './theme-panel.component.html',
  standalone: true,
  imports: [ CommonModule] 
})

export class ThemePanelComponent implements OnInit {
	@Output() appDarkModeChanged = new EventEmitter<boolean>();
	@Output() appThemeChanged = new EventEmitter<boolean>();
	appVariables = this.appVariablesService.getAppVariables();
	
	constructor(public appSettings: AppSettings, private appVariablesService: AppVariablesService) { }
	
	active: boolean = false;
	appThemeDarkModeCheckbox: boolean = false;
	appHeaderFixedCheckbox: boolean = true;
	appHeaderInverseCheckbox: boolean = false;
	appSidebarFixedCheckbox: boolean = true;
	appSidebarGridCheckbox: boolean = false;
	appGradientEnabledCheckbox: boolean = false;
	
	selectedTheme = 'teal';
	themes = ['red','pink','orange','yellow','lime','green','teal','cyan','blue','purple','indigo','gray-500'];
	
	toggleThemePanel() {
		if (localStorage) {
			localStorage['appThemePanelActive'] = !this.active;
		}
		this.active = !this.active;
	}
	
	ngOnInit() {
		var elm = document.querySelectorAll('[data-bs-toggle="tooltip"]');
		
		for (var i = 0; i < elm.length; i++) {
			new bootstrap.Tooltip(elm[i]);
		}
		if (localStorage) {
			if (localStorage['appDarkMode'] && localStorage['appDarkMode'] === 'true') {
				this.appThemeDarkModeCheckbox = true;
				this.appDarkModeChanged.emit(true);
			}
			if (localStorage['appHeaderFixed'] && localStorage['appHeaderFixed'] !== 'true') {
				this.appHeaderFixedCheckbox = false;
			}
			if (localStorage['appHeaderInverse'] && localStorage['appHeaderInverse'] === 'true') {
				this.appHeaderInverseCheckbox = true;
			}
			if (localStorage['appSidebarFixed'] && localStorage['appSidebarFixed'] !== 'true') {
				this.appSidebarFixedCheckbox = false;
			}
			if (localStorage['appSidebarGrid'] && localStorage['appSidebarGrid'] === 'true') {
				this.appSidebarGridCheckbox = true;
			}
			if (localStorage['appGradientEnabled'] && localStorage['appGradientEnabled'] === 'true') {
				this.appGradientEnabledCheckbox = true;
			}
		}
	}
	
		
	toggleDarkMode(e) {
		this.appSettings.appDarkMode = e.srcElement.checked;
		localStorage['appDarkMode'] = e.srcElement.checked;
		this.appDarkModeChanged.emit(true);	
		this.toggleThemePanel() 	
	}
	
	
	toggleGradientEnabled(e) {
		this.appSettings.appGradientEnabled = e.srcElement.checked;
		
			localStorage['appGradientEnabled'] = e.srcElement.checked;
			this.appDarkModeChanged.emit(true);	
		
	}
}
